import { render, staticRenderFns } from "./customerAccounts.vue?vue&type=template&id=cf189a06&"
import script from "./customerAccounts.vue?vue&type=script&lang=js&"
export * from "./customerAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports